import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import DatePicker from "react-datepicker";
import { FaEdit, FaTimesCircle, FaCheckSquare ,FaCalendarAlt} from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import "./Transactions.css";

const ITEMS_PER_PAGE = 10;

const CoachAssignmentPanel = () => {
    const [progressData, setProgressData] = useState([]);
    const [users, setUsers] = useState([]);
    const [courses, setCourses] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [coachInput, setCoachInput] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [filteredData, setFilteredData] = useState([]);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [progressRes, usersRes, coursesRes, schedulesRes] = await Promise.all([
                    axios.get(`${API_BASE_URL}/progress/allProgress`, {
                        headers: { Authorization: `Bearer ${token}` },
                    }),
                    axios.get(`${API_BASE_URL}/users`, {
                        headers: { Authorization: `Bearer ${token}` },
                    }),
                    axios.get(`${API_BASE_URL}/courses/allCourses`, {
                        headers: { Authorization: `Bearer ${token}` },
                    }),
                    axios.get(`${API_BASE_URL}/schedules/all`, {
                        headers: { Authorization: `Bearer ${token}` },
                    }),
                ]);

                setProgressData(progressRes.data);
                setFilteredData(progressRes.data); // initialize
                setUsers(usersRes.data);
                setCourses(coursesRes.data);
                setSchedules(schedulesRes.data);
            } catch (err) {
                console.error("Error loading data:", err);
            }
        };

        fetchData();
    }, []);

    const getUserName = (id) => {
        const user = users.find((u) => u.id === id);
        return user ? user.name : "—";
    };

    const getCourseTitle = (id) => {
        const course = courses.find((c) => c.id === id);
        return course ? course.title : "—";
    };

    const getFirstClassDate = (userId, courseId) => {
        const userSchedules = schedules.filter(
            (s) => s.course?.id === courseId && s.users?.some((u) => u && u.id === userId)
        );
        if (!userSchedules.length) return null;
        const earliest = userSchedules.reduce((a, b) =>
            new Date(a.date) < new Date(b.date) ? a : b
        );
        return new Date(earliest.date);
    };

    const handleDateRangeChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);

        const filtered = progressData.filter((record) => {
            const classDate = getFirstClassDate(record.userId, record.courseId);
            return (
                (!start || !classDate || classDate >= start) &&
                (!end || !classDate || classDate <= end)
            );
        });

        setFilteredData(filtered);
        setCurrentPage(1);
    };

    const handleEdit = (id, currentCoach) => {
        setEditingId(id);
        setCoachInput(currentCoach);
    };

    const handleSave = async (record) => {
        try {
            await axios.post(
                `${API_BASE_URL}/progress/update`,
                { userId: record.userId, courseId: record.courseId, coach: coachInput },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setProgressData((prev) =>
                prev.map((r) => (r.id === record.id ? { ...r, coach: coachInput } : r))
            );
            setFilteredData((prev) =>
                prev.map((r) => (r.id === record.id ? { ...r, coach: coachInput } : r))
            );
            setEditingId(null);
        } catch (err) {
            console.error("Error updating coach:", err);
        }
    };

    const paginatedData = filteredData.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    return (
        <div className="dashboard-wrapper">
            <div className="sidebar-fixed">
                <Sidebar />
            </div>
            <div className="dashboard-main">
                <Navbar />

                <div className="transaction-content">
                    <div className="table-container">
                        <div className="table-header">
                            <h4 className="section-title">Coach Assignment Panel</h4>
                            <div className="date-range">
                                <FaCalendarAlt />
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleDateRangeChange}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange
                                    isClearable
                                    placeholderText="Filter by 1st class date"
                                    className="date-picker-input"
                                />
                            </div>
                        </div>

                        <div className="table-scroll-wrapper">
                            <table className="transactions-table">
                                <thead>
                                    <tr>
                                        <th>Student Name</th>
                                        <th>Course</th>
                                        <th>Assigned Coach</th>
                                        <th>1st Class Date</th>
                                        <th>Assignment Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedData.map((record) => {
                                        const firstClass = getFirstClassDate(record.userId, record.courseId);
                                        return (
                                            <tr key={record.id}>
                                                <td>{getUserName(record.userId)}</td>
                                                <td>{getCourseTitle(record.courseId)}</td>
                                                <td>
                                                    {editingId === record.id ? (
                                                        <input
                                                            value={coachInput}
                                                            onChange={(e) => setCoachInput(e.target.value)}
                                                        />
                                                    ) : (
                                                        record.coach || "—"
                                                    )}
                                                </td>
                                                <td>{firstClass ? firstClass.toISOString().slice(0, 10) : "—"}</td>
                                                <td>
                                                    {editingId === record.id ? (
                                                        <button
                                                            className="status-btn editable"
                                                            onClick={() => handleSave(record)}
                                                        >
                                                            <FaCheckSquare /> Save
                                                        </button>
                                                    ) : record.coach ? (
                                                        <button className="status-btn locked" disabled>
                                                            <FaTimesCircle /> Locked

                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="status-btn editable"
                                                            onClick={() => handleEdit(record.id, record.coach)}
                                                        >
                                                            <FaEdit /> Editable
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            <div className="pagination">
                                {Array.from({
                                    length: Math.ceil(filteredData.length / ITEMS_PER_PAGE),
                                }).map((_, index) => (
                                    <button
                                        key={index}
                                        className={currentPage === index + 1 ? "active" : ""}
                                        onClick={() => setCurrentPage(index + 1)}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoachAssignmentPanel;
